// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* outer wrapper */
.tabs-container {
  width: 100%;
  /* background: #f5f7fb; */
  border-radius: 30px 30px 0px 0px;
  overflow: hidden;
}

/* tabs row */
.tabs-header {
  display: flex;
  gap: 32px;
  padding: 20px 24px 0 24px;
  border-bottom: 1px solid #e5e7eb;
}

/* button reset */
.tab-button-customer {
  position: relative;
  background: none;
  border: none;
  padding: 0 0 16px 0;
  cursor: pointer;

  font-size: 14px;
  font-weight: 600;
  color: #6b7280;

  transition: 0.3s ease;
}

/* hover */
.tab-button-customer:hover {
  color: #374151;
}

/* active tab */
.tab-button-customer.active {
  color: #2563eb;
}

/* blue bottom line */
.active-line {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 3px;
  background: #2563eb;
  border-radius: 999px;
}

/* ═══ DARK THEME — CustomerCustomTab ═══ */
.dark .tabs-header {
  border-bottom-color: #334155;
}
.dark .tab-button-customer { color: #64748b; }
.dark .tab-button-customer:hover { color: #cbd5e1; }
.dark .tab-button-customer.active { color: #3b82f6; }
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/components/CustomerCustomTab/CustomerCustomTab.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,WAAW;EACX,yBAAyB;EACzB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,eAAe;;EAEf,eAAe;EACf,gBAAgB;EAChB,cAAc;;EAEd,qBAAqB;AACvB;;AAEA,UAAU;AACV;EACE,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,2CAA2C;AAC3C;EACE,4BAA4B;AAC9B;AACA,6BAA6B,cAAc,EAAE;AAC7C,mCAAmC,cAAc,EAAE;AACnD,oCAAoC,cAAc,EAAE","sourcesContent":["/* outer wrapper */\n.tabs-container {\n  width: 100%;\n  /* background: #f5f7fb; */\n  border-radius: 30px 30px 0px 0px;\n  overflow: hidden;\n}\n\n/* tabs row */\n.tabs-header {\n  display: flex;\n  gap: 32px;\n  padding: 20px 24px 0 24px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n/* button reset */\n.tab-button-customer {\n  position: relative;\n  background: none;\n  border: none;\n  padding: 0 0 16px 0;\n  cursor: pointer;\n\n  font-size: 14px;\n  font-weight: 600;\n  color: #6b7280;\n\n  transition: 0.3s ease;\n}\n\n/* hover */\n.tab-button-customer:hover {\n  color: #374151;\n}\n\n/* active tab */\n.tab-button-customer.active {\n  color: #2563eb;\n}\n\n/* blue bottom line */\n.active-line {\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  height: 3px;\n  background: #2563eb;\n  border-radius: 999px;\n}\n\n/* ═══ DARK THEME — CustomerCustomTab ═══ */\n.dark .tabs-header {\n  border-bottom-color: #334155;\n}\n.dark .tab-button-customer { color: #64748b; }\n.dark .tab-button-customer:hover { color: #cbd5e1; }\n.dark .tab-button-customer.active { color: #3b82f6; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
